<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <span>Dashboard Revenda</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area" id="dashboard-solar">
        <div class="row">
          <div class="col-md-12 d-flex d-flex-just-beteween">
            <a href="/calculadora-aldo-solar/novo" class="btn-lista">Novo</a>
            <a href="/calculadora-aldo-solar/projetos" class="btn-lista">Lista de Projetos</a>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="wrapper-content border-radius bg-gray-50">
              <div class="row">
                <div class="col-md-12">
                  <h4>Visão Geral</h4>
                </div>
              </div>
              <div class="d-flex d-flex-wrap d-flex-just-beteween">
                <div
                  class="border-radius border-darkblue-solid d-flex flex-align-items-center flex-just-cont-center box-chart-general"
                  v-for="(Indicador, index) in ResumoGeral"
                  :key="index"
                >
                  <div class="value">{{Indicador.Value}}</div>
                  <span class="description">{{Indicador.Label}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-md-6 col-sm-12 border-radius">
                <Select2
                v-model="ResumoStatusAno"
                :options="Anos"
                :settings="{  }"
                @select="ResumoStatusAnoSelect($event)"
                style="font-size: 18px !important;"
              />
            <br>
            <!-- Acordion -->
            <Loader v-if="!historicoLoaded" />
            <BulmaAccordion :dropdown="false" initialOpenItem="1" v-if="historicoLoaded">
              <BulmaAccordionItem v-for="(item, index) in ResumoStatus" v-bind:key="index">
                <h4 slot="title" v-html="item.Status"></h4>
                <div slot="content">
                  <div class="d-flex d-flex-wrap d-flex-just-beteween">
                    <div
                      class="border-radius border-darkblue-solid d-flex flex-align-items-center flex-just-cont-center box-chart-general content-30 mb30"
                      v-for="(Indicador, index) in item.Quadros"
                      :key="index"
                    >
                      <span class="description">{{Indicador.label}}</span>
                      <div class="value">{{Indicador.value}}</div>
                    </div>
                  </div>
                  <div class="wrapper-content border-radius border-gray-solid">
                    <div class="options d-flex d-flex-just-beteween" style="align-items:center">
                      <h5>Histórico de Propostas Emitidas</h5>
                    </div>

                    <line-chart
                      v-if="historicoLoaded"
                      :chartData="item.ResumoAnual[0]"
                      :options="optionsResumo"
                      :chart-id="'chart-revenda-' + index"
                      height="100"
                    ></line-chart>
                  </div>
                </div>
              </BulmaAccordionItem>
            </BulmaAccordion>

            <!-- Fim acordion -->
          </div>
          <div class="col-md-6 col-sm-12 bg-gray-50 border-radius">
            <div class="wrapper-content-15">
              <div class="row">
                <div class="col-md-12">
                  <div class="content-100">
                    <h4>Projetos</h4>
                  </div>
                  <div class="wrapper-content border-radius border-gray-solid">
                    <div class="row">
                      <div class="col-md-12 d-flex d-flex-just-beteween mb30">
                        <div class="content-40">
                          <h5>Projetos por Status</h5>
                        </div>
                        <div
                          class="d-flex content-60 d-flex-just-evenly"
                          style="align-items:center"
                        >
                          <Select2
                            v-model="ProjetoStatusAno"
                            :options="Anos"
                            :settings="{  }"
                            @select="ProjetoStatusAnoSelect($event)"
                          />
                          <Select2
                            v-model="ProjetoStatusMes"
                            :options="Meses"
                            :settings="{ }"
                            @select="ProjetoStatusMesSelect($event)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <Loader v-if="!ProjetoStatusLoaded" />
                        <bar-chart
                          :data="ProjetoStatus"
                          v-if="ProjetoStatusLoaded && ProjetoStatus.datasets[0].data.length > 0"
                          :options="options"
                          chart-id="chart-revenda-barra"
                        ></bar-chart>
                        <div class="text-center" v-else-if="ProjetoStatusLoaded">
                          <h4>Sem Dados Para Exibição</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="row">
                <div class="col-md-12">
                  <div class="wrapper-content border-radius border-gray-solid">
                    <div class="row">
                      <div class="col-md-12 d-flex d-flex-just-beteween mb30">
                        <FunnelChart
                          v-if="this.funil.labels"
                          :labels="this.funil.labels"
                          :dataChart="this.funil.data"
                        ></FunnelChart>
                      </div>
                    </div>
                  </div>
                </div>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import axios from "axios";
import BarChart from "./Components/BarChart.vue";
import LineChart from "./Components/LineChart.vue";
import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";
// import FunnelChart from "./Components/FunnelChart";
import Select2 from "v-select2-component";

export default {
  name: "DashResaler",
  components: {
    BarChart,
    LineChart,
    BulmaAccordion,
    BulmaAccordionItem,
    // FunnelChart,
    Select2
  },
  beforeMounted() {},
  async mounted() {
    this.Anos = this.listarAnos();
    const self = this;
    $.ajax({
      url: this.$apiUrl + "Session.svc/getsessions",
      dataType: "json",
      type: "GET",
      xhrFields: { withCredentials: true },
      error: () => {
        swal({
          title: "É necessário estar logado",
          icon: "warning"
        }).then(
          () =>
            (location.href =
              `${self.$SiteUrl}/login?redirectTo=` + location.href)
        );
      },
      success: response => {
        if (response.DadosCliente.TipoUsuario == 2) {
          location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href;
        }
      }
    });

    this.fillVisaoGeral();
    this.fillProjetoStatusAno();
    this.fillPorStatusGrafico();
    //this.fillVisaoGeral();
    // this.fillFunil();
  },
  data: () => ({
    Meses: [
      { id: 1, text: "Jan" },
      { id: 2, text: "Fev" },
      { id: 3, text: "Mar" },
      { id: 4, text: "Abr" },
      { id: 5, text: "Mai" },
      { id: 6, text: "Jun" },
      { id: 7, text: "Jul" },
      { id: 8, text: "Ago" },
      { id: 9, text: "Set" },
      { id: 10, text: "Out" },
      { id: 11, text: "Nov" },
      { id: 12, text: "Dez" }
    ],

    Anos: null,
    ResumoGeral: [],
    funil: {
      data: null,
      labels: null
    },
    ProjetoStatusMes: new Date().getMonth() + 1,
    ProjetoStatusAno: new Date().getFullYear(),
    ProjetoStatus: null,
    ProjetoStatusLoaded: false,
    historicoLoaded: false,
    options: {
      animation: {
        duration: 0
      },
      layout: {
        padding: {
          left: 20,
          right: 20,
          top: 15,
          bottom: 20
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      plugins: {
        datalabels: {
          color: "#021746",
          labels: {
            title: {
              align: "top"
            }
          }
        }
      },
      scales: {
        yAxes: [
          {
            display: false,
            gridLines: {
              display: false
            },
            ticks: {
              beginAtZero: true
            }
          }
        ],
        xAxes: [
          {
            gridLines: {
              display: false
            }
          }
        ]
      }
    },
    ResumoStatus: [],
    ResumoStatusAno: new Date().getFullYear(),
    optionsResumo: {
            animation: {
        duration: 0
      },
      layout: {
        padding: {
            left: 20,
            right: 20,
            top: 45,
            bottom: 20
          }
      },
      plugins: {
        datalabels: {
          color: "#021746",
          labels: {
            title: {
              align: "top"
            }
          }
        }
      },
      legend: {
        display: false
      },
      scales: {
        yAxes: [
          {
            display: false,
            gridLines: {
              display: false
            }
          }
        ],
        xAxes: [
          {
            display: true,
            gridLines: {
              display: false
            }
          }
        ]
      }
    }
  }),
  computed: {},
  methods: {
    listarAnos: function(){
      var ano = 2018;
      var anoFinal = new Date().getFullYear();
      var anos = [];
      for(; ano <= anoFinal; ano++){
        anos.push(ano);
      }
      return anos;
    },
    ProjetoStatusMesSelect: function(val) {
      this.ProjetoStatusMes = val.id;
      this.fillPorStatusGrafico();
    },
    ProjetoStatusAnoSelect: function(val) {
      this.ProjetoStatusAno = val.id;
      this.fillPorStatusGrafico();
    },
    ResumoStatusAnoSelect: function(val) {
      this.ResumoStatusAno = val.id;
      this.fillProjetoStatusAno();
    },
    fillVisaoGeral: function() {
      const self = this;
      //Dados gerais direita
      axios
        .get(this.$apiUrl + "Projeto.svc/dashboard/revenda/visaogeral", {
          withCredentials: true
        })
        .then(function(response) {
          self.ResumoGeral = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    fillProjetoStatusAno: function() {
      const self = this;
      this.historicoLoaded = false;
      axios
        .get(
          this.$apiUrl +
            `Projeto.svc/dashboard/revenda/ProjetoStatusAno?ano=${self.ResumoStatusAno}`,
          {
            withCredentials: true
          }
        )
        .then(function(response) {
          self.ResumoStatus = [];

          for (let index = 0; index < response.data.length; index++) {
            const element = response.data[index];
            var item = {
              Status: element.Status,
              Quadros: [
                { label: "Quantidade de Projetos", value: element.Qtde },
                { label: "Valor Total de Projetos", value: element.ValorTotal },
                {
                  label: "Potência total de Projetos",
                  value: element.TotalPotencia
                }
              ],
              ResumoAnual: [
                {
                  datasets: [
                    {
                      backgroundColor: "transparent",
                      borderJoinStyle: "bevel",
                      lineTension: 0,
                      borderColor: "rgb(240,230,140)",
                      borderWidth: 1,
                      pointBorderWidth: 1,
                      pointBorderColor: "rgb(30,144,255)",
                      pointBackgroundColor: "rgb(240,230,140)",
                      data: element.TotalMes
                    }
                  ],
                  labels: element.Mes
                }
              ]
            };

            self.ResumoStatus.push(item);
          }
          self.historicoLoaded = true;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    fillPorStatusGrafico: function() {
      let self = this;
      self.ProjetoStatus = null;
      self.ProjetoStatusLoaded = false;
      axios
        .get(
          this.$apiUrl +
            `Projeto.svc/dashboard/revenda/ProjetoStatus?ano=${self.ProjetoStatusAno}&mes=${self.ProjetoStatusMes}`,
          { withCredentials: true }
        )
        .then(function(response) {
          self.ProjetoStatus = {
            labels: response.data.labels,
            datasets: [
              {
                backgroundColor: [
                  "rgb(175,238,238)",
                  "rgb(250,250,210)",
                  "rgb(135,206,235)",
                  "rgb(152,251,152)",
                  "rgb(176,224,230)",
                  "rgb(240,230,140)",
                  "rgb(238,232,170",
                  "rgb(230,230,250)"
                ],
                data: response.data.Qtde
              }
            ]
          };

         self.ProjetoStatusLoaded = true;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
    //,
    // fillFunil: function() {
    //   const self = this;

    //   axios
    //     .get(this.$apiUrl + "Projeto.svc/dashboard/revenda/ProjetoFunil", {
    //       withCredentials: true
    //     })
    //     .then(function(response) {
    //       self.funil.labels = response.data.labels;
    //       self.funil.data = response.data.data;
    //     })
    //     .catch(function(error) {
    //       console.log(error);
    //     });
    // }
  }
};
</script>